'use client'

export const PAYMENT_METHOD_OPEN_EVENT = 'ql7:payment-method:open'
export const PAYMENT_METHOD_RESULT_EVENT = 'ql7:payment-method:result'
export const DIGITAL_TERMS_OPEN_EVENT = 'ql7:digital-terms:open'
export const DIGITAL_TERMS_RESULT_EVENT = 'ql7:digital-terms:result'

function createRequestId(prefix = 'pay') {
  try {
    if (typeof window.crypto?.randomUUID === 'function') return `${prefix}_${window.crypto.randomUUID()}`
  } catch {}
  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 14)}`
}

export function openDigitalTermsAcceptance({ source = 'purchase', purpose = '', accountId = '' } = {}) {
  if (typeof window === 'undefined') return Promise.resolve(false)

  const requestId = createRequestId('terms')
  return new Promise((resolve) => {
    const onResult = (event) => {
      if (event?.detail?.requestId !== requestId) return
      window.removeEventListener(DIGITAL_TERMS_RESULT_EVENT, onResult)
      resolve(event.detail.accepted === true)
    }

    window.addEventListener(DIGITAL_TERMS_RESULT_EVENT, onResult)
    window.dispatchEvent(new CustomEvent(DIGITAL_TERMS_OPEN_EVENT, {
      detail: {
        requestId,
        source: String(source || 'purchase').trim().toLowerCase(),
        purpose: String(purpose || '').trim().toLowerCase(),
        accountId: String(accountId || '').trim(),
      },
    }))
  })
}

export async function openPaymentMethodPopover({ accountId, purpose = 'vip', adsPackage = null } = {}) {
  if (typeof window === 'undefined') return null

  const cleanAccountId = String(accountId || '').trim()
  const cleanPurpose = String(purpose || '').trim().toLowerCase()
  const accepted = await openDigitalTermsAcceptance({
    source: 'quantum-pay',
    purpose: cleanPurpose,
    accountId: cleanAccountId,
  })
  if (!accepted) return null

  const requestId = createRequestId('pay')
  return new Promise((resolve) => {
    const onResult = (event) => {
      if (event?.detail?.requestId !== requestId) return
      window.removeEventListener(PAYMENT_METHOD_RESULT_EVENT, onResult)
      resolve(event.detail.result || null)
    }

    window.addEventListener(PAYMENT_METHOD_RESULT_EVENT, onResult)
    window.dispatchEvent(new CustomEvent(PAYMENT_METHOD_OPEN_EVENT, {
      detail: {
        requestId,
        accountId: cleanAccountId,
        purpose: cleanPurpose,
        adsPackage: adsPackage ? String(adsPackage).trim().toUpperCase() : null,
      },
    }))
  })
}
